import { useState, useEffect } from "react";
import "./Terms.css";

const Terms = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
  }, []);

  const sections = [
    {
      num: "1",
      title: "Acceptance of Terms",
      content:
        "By accessing or using the MKM Thangamaligai website, you agree to be bound by these Terms of Use and all applicable laws and regulations. If you do not agree, please do not use the site.",
    },
    {
      num: "2",
      title: "Intellectual Property Rights",
      content:
        "All content on this website including text, images, graphics, and logos are the property of MKM Thangamaligai and protected by copyright and trademark laws. Reproduction without permission is strictly prohibited.",
    },
    {
      num: "3",
      title: "User Conduct",
      content:
        "You agree to use the website only for lawful purposes and in a way that does not infringe upon the rights of others or restrict their use of the site.",
    },
    {
      num: "4",
      title: "Product Information",
      content:
        "We strive for accuracy but do not guarantee that product descriptions, prices, or other content are error-free. We reserve the right to correct errors and update information at any time.",
    },
    {
      num: "5",
      title: "Limitation of Liability",
      content:
        "MKM Thangamaligai will not be held liable for any damages arising from your use of the site or from any content, products, or services obtained through it.",
    },
    {
      num: "6",
      title: "Changes to Terms",
      content:
        "We may revise these Terms of Use at any time without prior notice. By continuing to use the website, you agree to be bound by the updated terms.",
    },
    {
      num: "7",
      title: "Contact Us",
      content: (
        <>
          If you have any questions regarding these Terms of Use, please contact
          us at:{" "}
          <a
            href="mailto:mkmthangamaligai@gmail.com"
            style={{ color: "#9c7814", textDecoration: "none" }}
          >
            mkmthangamaligai@gmail.com
          </a>
        </>
      ),
    },
  ];

  return (
    <div className="terms-wrapper">
      <div className={`terms-hero ${visible ? "visible" : ""}`}>
        <h1>T<span className="SmallLetter">erms <t/><t/> and </span>C<span className="SmallLetter">ondition</span></h1>
        <p>Please read these terms carefully before using our website.</p>
      </div>

      <div className="terms-body">
        {sections.map((s, i) => (
          <SectionItem key={s.num} section={s} delay={i * 80} />
        ))}
      </div>
    </div>
  );
};

const SectionItem = ({ section, delay }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 300 + delay);
    return () => clearTimeout(t);
  }, [delay]);

  return (
    <div
      className={`terms-section ${visible ? "visible" : ""}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="divider" />
      <h2>
        {section.num}. {section.title}
      </h2>
      <p>{section.content}</p>
    </div>
  );
};

export default Terms;